import { COMMENT_VIEW, AI_VIEW, METADATA_VIEW } from 'components/DocRightRail/Constants'
import { CONTENT_CHANNELS } from 'components/Wizards/WizardsV3/constants'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { useArticleView } from 'providers/ArticleViewProvider/ArticleViewProvider'
import { ArticleFlat, ArticleView, TextChannelKey } from 'types'
import { isExternalResource } from 'utils/articleUtils'

type Props = {
  article: ArticleFlat
}

export const useAvailableTabs = ({ article }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const articleView = useArticleView()
  const isArticleExternalResource = isExternalResource(article)
  const docChannel = article.channel

  return {
    [AI_VIEW]: !isArticleExternalResource && articleView === ArticleView.Editing,
    [COMMENT_VIEW]: articleView === ArticleView.Editing || articleView === ArticleView.Commenting,
    [METADATA_VIEW]: isSystemRedesignEnabled && CONTENT_CHANNELS.includes(docChannel as TextChannelKey),
  }
}
